export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: any;
  /** Convert to Action Dispatch Uploaded File */
  UploadFile: any;
};

/** Autogenerated input type of AddBankAccount */
export type AddBankAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  token: Scalars['String'];
  attributes: BankAccountAttributes;
};

/** Autogenerated return type of AddBankAccount */
export type AddBankAccountPayload = {
  __typename?: 'AddBankAccountPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Errors encountered during execution of the mutation. */
  errors: Array<Scalars['String']>;
  refund?: Maybe<Refund>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Return addon product information */
export type AddonProduct = {
  __typename?: 'AddonProduct';
  addonAttributes?: Maybe<Array<Scalars['String']>>;
  addonDescription?: Maybe<Scalars['String']>;
  estimate: EstimateItem;
  product: Product;
  sku: Sku;
};

/** Announcement data */
export type Announcement = {
  __typename?: 'Announcement';
  announcementType: Scalars['String'];
  content: Scalars['String'];
  displayMethod: Scalars['String'];
  id: Scalars['ID'];
  publishDate: Scalars['String'];
  url?: Maybe<Scalars['String']>;
};

export enum AnnouncementPlaceEnum {
  AllCategoryPages = 'all_category_pages',
  AllProductPages = 'all_product_pages',
  TopPage = 'top_page'
}

/** Return application data */
export type ApplicationData = {
  __typename?: 'ApplicationData';
  authenticityToken?: Maybe<Scalars['String']>;
  cartItemCount: Scalars['Int'];
  contactLink: Scalars['String'];
  contactPhoneNumber: Scalars['String'];
  isCorporateUser: Scalars['Boolean'];
  isPrimeUser: Scalars['Boolean'];
  omniauthRequestPath: Scalars['String'];
  orderHistoryCount: Scalars['Int'];
  raksulCoreUrl: Scalars['String'];
  showPhoneContact: Scalars['Boolean'];
};

/** Bank data */
export type Bank = {
  __typename?: 'Bank';
  bankBranches: Array<BankBranch>;
  coreId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  ruby: Scalars['String'];
};

/** Attributes for updating a refund to the bank account */
export type BankAccountAttributes = {
  bankBranchId: Scalars['ID'];
  accountType: Scalars['String'];
  accountName: Scalars['String'];
  accountNumber: Scalars['String'];
};

/** Bank Branch data */
export type BankBranch = {
  __typename?: 'BankBranch';
  bank: Bank;
  coreId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  ruby: Scalars['String'];
};

/** BankRefundType data */
export type BankRefund = {
  __typename?: 'BankRefund';
  accountName: Scalars['String'];
  accountNumber: Scalars['String'];
  accountType: Scalars['String'];
  bankBranch: BankBranch;
  id: Scalars['ID'];
};

/** Brand data */
export type Brand = {
  __typename?: 'Brand';
  brandName: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  id: Scalars['ID'];
  industryPageBestSellingProducts: Array<ProductSearchDetail>;
  logoImage?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of CancelOrder */
export type CancelOrderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  displayId: Scalars['String'];
};

/** Autogenerated return type of CancelOrder */
export type CancelOrderPayload = {
  __typename?: 'CancelOrderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Errors encountered during execution of the mutation. */
  errors: Array<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Carousel image data */
export type CarouselImage = {
  __typename?: 'CarouselImage';
  altText?: Maybe<Scalars['String']>;
  destinationUrl: Scalars['String'];
  id: Scalars['ID'];
  image: Scalars['String'];
  mobileImage?: Maybe<Scalars['String']>;
};

/** Cart Item data */
export type CartItem = {
  __typename?: 'CartItem';
  allOptions: Array<Option>;
  amount: Scalars['Int'];
  availableSizes: Array<Size>;
  displayPlateChargeTaxIncluded: Scalars['Int'];
  fastShippingFeeTaxIncluded: Scalars['Int'];
  hasStock: Scalars['Boolean'];
  hasSubmissions: Scalars['Boolean'];
  id: Scalars['ID'];
  isAddon: Scalars['Boolean'];
  isBuyLater: Scalars['Boolean'];
  isReorder: Scalars['Boolean'];
  options: Array<Option>;
  plainGood: Scalars['Boolean'];
  plainGoodByUser: Scalars['Boolean'];
  previewFiles?: Maybe<Array<Maybe<Scalars['String']>>>;
  priceWithCharges: Scalars['Int'];
  priceWithChargesTaxIncluded: Scalars['Int'];
  printableSku: PrintableSku;
  printableSkuId: Scalars['ID'];
  printingPriceTaxIncluded: Scalars['Int'];
  product: Product;
  productPriceTaxIncluded: Scalars['Int'];
  productUnitPriceTaxIncluded: Scalars['Int'];
  publishStatus: Scalars['String'];
  quantity: Scalars['Int'];
  repeatDiscountTaxIncluded: Scalars['Int'];
  selectedPrintingColor?: Maybe<SkuPrintableSpecialColor>;
  shortestDeliveryDate: Scalars['String'];
  shortestShippingDate: Scalars['String'];
  sizeItems: Array<SizeItem>;
  thumbnailImages?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** Return cart items */
export type CartItems = {
  __typename?: 'CartItems';
  amount: Scalars['Int'];
  fastShippingFeeTaxIncluded: Scalars['Int'];
  items: Array<CartItem>;
  originalPricesTaxIncluded: Scalars['Int'];
  totalRepeatDiscountTaxIncluded: Scalars['Int'];
};

/** Category data */
export type Category = {
  __typename?: 'Category';
  brandChildCategoriesWithProducts: Array<Category>;
  campaignLowestPrice?: Maybe<Scalars['Float']>;
  categoryBanners?: Maybe<Array<CategoryBanner>>;
  categorySections?: Maybe<Array<CategorySection>>;
  childCategories?: Maybe<Array<Category>>;
  childCategoriesWithProducts: Array<Category>;
  childCategoriesWithProductsV2: Array<Category>;
  description?: Maybe<Scalars['String']>;
  detail?: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  fullColorChildCategories?: Maybe<Array<Category>>;
  iconImage: Scalars['String'];
  iconImageAlt?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  industries?: Maybe<Array<Industry>>;
  industryCategoryBanner: Scalars['String'];
  industryImage: Scalars['String'];
  industryPageBestSellingProducts: Array<ProductSearchDetail>;
  industryPageTopRankingProducts: Array<ProductSearchDetail>;
  lead: Scalars['String'];
  lowestPrice: Scalars['Float'];
  mainImage: Scalars['String'];
  mainImageAlt?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  parentCategory?: Maybe<Category>;
  quantityUnit: Scalars['String'];
  shortDisplayName: Scalars['String'];
  shortestShippingDates?: Maybe<ShortestShippingDate>;
  title: Scalars['String'];
  topPageImage: Scalars['String'];
  topPageImageAlt?: Maybe<Scalars['String']>;
  topRankingCategories: Array<Category>;
  url: Scalars['String'];
};


/** Category data */
export type CategoryBrandChildCategoriesWithProductsArgs = {
  brandId: Scalars['ID'];
};


/** Category data */
export type CategoryChildCategoriesWithProductsArgs = {
  industryId?: Maybe<Scalars['ID']>;
};


/** Category data */
export type CategoryIndustryImageArgs = {
  industryId?: Maybe<Scalars['ID']>;
};

/** Category banner data */
export type CategoryBanner = {
  __typename?: 'CategoryBanner';
  altText: Scalars['String'];
  destinationUrl?: Maybe<Scalars['String']>;
  displayMethod: Scalars['String'];
  id: Scalars['ID'];
  image: Scalars['String'];
};

/** Category search result data */
export type CategorySearchResult = {
  __typename?: 'CategorySearchResult';
  childCategories?: Maybe<Array<CategorySearchResult>>;
  displayName: Scalars['String'];
  hasPage?: Maybe<Scalars['Boolean']>;
  iconImageAlt?: Maybe<Scalars['String']>;
  iconImageUrl: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  shortDisplayName: Scalars['String'];
  topPageImageAlt?: Maybe<Scalars['String']>;
  topSearchCount?: Maybe<Scalars['Int']>;
  url: Scalars['String'];
};

/** Category section data */
export type CategorySection = {
  __typename?: 'CategorySection';
  iconImage?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  sectionType?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<ProductsGroupByTag>>;
  title: Scalars['String'];
};

/** Cms breadcrumb */
export type CmsBreadcrumb = {
  __typename?: 'CmsBreadcrumb';
  displayName: Scalars['String'];
  id: Scalars['ID'];
  url: Scalars['String'];
};

/** Pagination for cms categories */
export type CmsCategories = {
  __typename?: 'CmsCategories';
  items: Array<CmsCategory>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  totalItemsCount: Scalars['Int'];
};

/** Cms category */
export type CmsCategory = {
  __typename?: 'CmsCategory';
  breadcrumbs: Array<CmsBreadcrumb>;
  createdAt: Scalars['String'];
  description: Scalars['String'];
  detail?: Maybe<Scalars['String']>;
  h1: Scalars['String'];
  h2: Scalars['String'];
  id: Scalars['ID'];
  mainImage?: Maybe<Scalars['String']>;
  mainImageAlt: Scalars['String'];
  mainImageBrandName?: Maybe<Scalars['String']>;
  mainImageDescription?: Maybe<Scalars['String']>;
  metaDescription: Scalars['String'];
  path: Scalars['String'];
  products: Array<ProductSearchDetail>;
  title: Scalars['String'];
  totalProductCount: Scalars['Int'];
  updatedAt: Scalars['String'];
  url: Scalars['String'];
  urlEffect: Scalars['Int'];
};

/** Cms Magazine */
export type CmsMagazine = {
  __typename?: 'CmsMagazine';
  cmsMagazineBlocks: Array<CmsMagazineBlock>;
  cmsTags: Array<CmsTag>;
  cssFile?: Maybe<Scalars['String']>;
  followStatus: Scalars['String'];
  h1: Scalars['String'];
  id: Scalars['ID'];
  indexStatus: Scalars['String'];
  magazineType: Scalars['String'];
  mainImage: Scalars['String'];
  mainImageHeight?: Maybe<Scalars['Int']>;
  mainImageWidth?: Maybe<Scalars['Int']>;
  metaDescription: Scalars['String'];
  path: Scalars['String'];
  publishStatus: Scalars['String'];
  publishedAt?: Maybe<Scalars['String']>;
  publishedAtTimestamp?: Maybe<Scalars['String']>;
  tagRelatedCmsMagazines: Array<CmsMagazine>;
  title: Scalars['String'];
  updatedAt: Scalars['String'];
  updatedAtTimestamp: Scalars['String'];
  url: Scalars['String'];
};


/** Cms Magazine */
export type CmsMagazineTagRelatedCmsMagazinesArgs = {
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};

/** Cms magazine block */
export type CmsMagazineBlock = {
  __typename?: 'CmsMagazineBlock';
  alignment?: Maybe<Scalars['String']>;
  blockType: Scalars['String'];
  contentHtml?: Maybe<Scalars['String']>;
  description1?: Maybe<Scalars['String']>;
  description2?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  products?: Maybe<Array<ProductSearchDetail>>;
  title1?: Maybe<Scalars['String']>;
  title2?: Maybe<Scalars['String']>;
};

/** Pagination for cms magazines */
export type CmsMagazines = {
  __typename?: 'CmsMagazines';
  items: Array<CmsMagazine>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  totalItemsCount: Scalars['Int'];
};

/** Cms mapping */
export type CmsMapping = {
  __typename?: 'CmsMapping';
  cmsCategories: Array<CmsCategory>;
  cmsMagazines: Array<CmsMagazine>;
};

export enum CmsMappingTypeEnum {
  Industry = 'Industry',
  Category = 'Category',
  Brand = 'Brand'
}

/** Cms tag data */
export type CmsTag = {
  __typename?: 'CmsTag';
  keyword: Scalars['String'];
};

/** Color Pattern data */
export type ColorPattern = {
  __typename?: 'ColorPattern';
  cmykColorNum: Scalars['Int'];
  defaultPrintableLetterSize: Scalars['Int'];
  displayName: Scalars['String'];
  displayOrder: Scalars['Int'];
  id?: Maybe<Scalars['ID']>;
  image: Scalars['String'];
  lead: Scalars['String'];
  smallestPrintableLetterSize: Scalars['Int'];
  specialColorNum: Scalars['Int'];
  type: Scalars['String'];
};

/** Autogenerated input type of ConfirmOperatorModifiedSubmission */
export type ConfirmOperatorModifiedSubmissionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  orderItemDisplayId: Scalars['String'];
  submissionUuids?: Maybe<Array<Scalars['String']>>;
};

/** Autogenerated return type of ConfirmOperatorModifiedSubmission */
export type ConfirmOperatorModifiedSubmissionPayload = {
  __typename?: 'ConfirmOperatorModifiedSubmissionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Errors encountered during execution of the mutation. */
  errors: Array<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated input type of ConfirmSubmission */
export type ConfirmSubmissionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  orderItemDisplayId: Scalars['String'];
};

/** Autogenerated return type of ConfirmSubmission */
export type ConfirmSubmissionPayload = {
  __typename?: 'ConfirmSubmissionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Errors encountered during execution of the mutation. */
  errors: Array<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export enum ContactPurposeEnum {
  ProductAndPrices = 'product_and_prices',
  Orders = 'orders',
  SubmissionData = 'submission_data',
  DeliveryDate = 'delivery_date',
  DeliveredProduct = 'delivered_product',
  RequestTransactions = 'request_transactions',
  Other = 'other'
}

export type ConvenienceInfo = {
  __typename?: 'ConvenienceInfo';
  convenienceStores: Array<ConvenienceStore>;
  purchasableRange: ConveniencePurchasableRange;
};

export type ConveniencePurchasableRange = {
  __typename?: 'ConveniencePurchasableRange';
  maxAmount: Scalars['Int'];
  minAmount: Scalars['Int'];
};

export type ConvenienceStore = {
  __typename?: 'ConvenienceStore';
  code: Scalars['ID'];
  isMaintenanceScheduled: Scalars['Boolean'];
  isUnderMaintenance: Scalars['Boolean'];
  maintenanceEndDateTime?: Maybe<Scalars['String']>;
  maintenanceStartDateTime?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

/** Coupon Discount Type */
export type CouponDiscount = {
  __typename?: 'CouponDiscount';
  plateChargeDiscountTaxIncluded: Scalars['Int'];
  priceDiscountTaxIncluded: Scalars['Int'];
};

/** Attributes for creating cart item */
export type CreateCartItemAttributes = {
  printableSkuId: Scalars['ID'];
  addonPrintableSkuId?: Maybe<Scalars['ID']>;
  sizes: Array<SizeItemAttributes>;
  recart: Scalars['Boolean'];
  submissionUuids: Array<Scalars['String']>;
  skuPrintableSpecialColorIds: Array<Scalars['ID']>;
  skuPrintableCmykColorIds: Array<Scalars['ID']>;
  saveDesignToLibrary: Scalars['Boolean'];
  designInfo?: Maybe<Array<SubmissionDesignInfoAttributes>>;
  designVersionUuid?: Maybe<Scalars['String']>;
  plainGoodByUser?: Maybe<Scalars['Boolean']>;
  prefectureId?: Maybe<Scalars['ID']>;
  optionIds?: Maybe<Array<Scalars['ID']>>;
};

/** Autogenerated input type of CreateCartItem */
export type CreateCartItemInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: CreateCartItemAttributes;
};

/** Autogenerated return type of CreateCartItem */
export type CreateCartItemPayload = {
  __typename?: 'CreateCartItemPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Errors encountered during execution of the mutation. */
  errors: Array<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Attributes for creating catalog request */
export type CreateCatalogRequestAttributes = {
  companyName: Scalars['String'];
  department?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  email: Scalars['String'];
  zip: Scalars['String'];
  prefecture: Scalars['String'];
  city: Scalars['String'];
  address1: Scalars['String'];
  address2?: Maybe<Scalars['String']>;
  sentOtherInformation: Scalars['Boolean'];
};

/** Autogenerated input type of CreateCatalogRequest */
export type CreateCatalogRequestInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: CreateCatalogRequestAttributes;
};

/** Autogenerated return type of CreateCatalogRequest */
export type CreateCatalogRequestPayload = {
  __typename?: 'CreateCatalogRequestPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Errors encountered during execution of the mutation. */
  errors: Array<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Attributes for creating contact */
export type CreateContactAttributes = {
  fullName?: Maybe<Scalars['String']>;
  fullNameKana?: Maybe<Scalars['String']>;
  tel?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  purpose: ContactPurposeEnum;
  content: Scalars['String'];
  orderUuid?: Maybe<Scalars['String']>;
  files?: Maybe<Array<Scalars['UploadFile']>>;
};

/** Autogenerated input type of CreateContact */
export type CreateContactInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: CreateContactAttributes;
};

/** Autogenerated return type of CreateContact */
export type CreateContactPayload = {
  __typename?: 'CreateContactPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Errors encountered during execution of the mutation. */
  errors: Array<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Attributes for creating estimate item */
export type CreateEstimateItemAttributes = {
  printableSkuId: Scalars['ID'];
  addonPrintableSkuId?: Maybe<Scalars['ID']>;
  sizes: Array<SizeItemAttributes>;
  skuPrintableSpecialColorIds: Array<Scalars['ID']>;
  skuPrintableCmykColorIds: Array<Scalars['ID']>;
  optionIds?: Maybe<Array<Scalars['ID']>>;
};

/** Autogenerated input type of CreateEstimateItem */
export type CreateEstimateItemInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: CreateEstimateItemAttributes;
};

/** Autogenerated return type of CreateEstimateItem */
export type CreateEstimateItemPayload = {
  __typename?: 'CreateEstimateItemPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Errors encountered during execution of the mutation. */
  errors: Array<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Attributes for creating cart item from group buy item */
export type CreateFromGroupBuyItemAttributes = {
  uuid: Scalars['String'];
  submissionUuids: Array<Scalars['String']>;
  skuPrintableSpecialColorIds: Array<Scalars['ID']>;
};

/** Autogenerated input type of CreateFromGroupBuyItem */
export type CreateFromGroupBuyItemInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: CreateFromGroupBuyItemAttributes;
};

/** Autogenerated return type of CreateFromGroupBuyItem */
export type CreateFromGroupBuyItemPayload = {
  __typename?: 'CreateFromGroupBuyItemPayload';
  cartItem?: Maybe<CartItem>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Errors encountered during execution of the mutation. */
  errors: Array<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated input type of CreateGroupBuyItem */
export type CreateGroupBuyItemInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: GroupBuyItemAttributes;
};

/** Autogenerated return type of CreateGroupBuyItem */
export type CreateGroupBuyItemPayload = {
  __typename?: 'CreateGroupBuyItemPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Errors encountered during execution of the mutation. */
  errors: Array<Scalars['String']>;
  groupBuyItem?: Maybe<GroupBuyItem>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated input type of CreateGroupBuyRequest */
export type CreateGroupBuyRequestInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  uuid: Scalars['String'];
  attributes: GroupBuyRequestAttributes;
};

/** Autogenerated return type of CreateGroupBuyRequest */
export type CreateGroupBuyRequestPayload = {
  __typename?: 'CreateGroupBuyRequestPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Errors encountered during execution of the mutation. */
  errors: Array<Scalars['String']>;
  groupBuyRequest?: Maybe<GroupBuyRequest>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated input type of CreateUserDesign */
export type CreateUserDesignInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  userUploadImageUuids: Array<Scalars['String']>;
  fileExtension: UserDesignFileExtensionEnum;
};

/** Autogenerated return type of CreateUserDesign */
export type CreateUserDesignPayload = {
  __typename?: 'CreateUserDesignPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Errors encountered during execution of the mutation. */
  errors: Array<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
  userDesign?: Maybe<UserDesign>;
};

/** Autogenerated input type of CreateUserSizeRequest */
export type CreateUserSizeRequestInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  skuId: Scalars['ID'];
  sizeIds: Array<Scalars['ID']>;
};

/** Autogenerated return type of CreateUserSizeRequest */
export type CreateUserSizeRequestPayload = {
  __typename?: 'CreateUserSizeRequestPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Errors encountered during execution of the mutation. */
  errors: Array<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated input type of CreateUserUploadImageFromUserDesign */
export type CreateUserUploadImageFromUserDesignInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  userDesignVersionUuid: Scalars['String'];
  psi: Scalars['ID'];
};

/** Autogenerated return type of CreateUserUploadImageFromUserDesign */
export type CreateUserUploadImageFromUserDesignPayload = {
  __typename?: 'CreateUserUploadImageFromUserDesignPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Errors encountered during execution of the mutation. */
  errors: Array<Scalars['String']>;
  fileExtension?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type CreditCard = {
  __typename?: 'CreditCard';
  isMaintenanceScheduled: Scalars['Boolean'];
  isUnderMaintenance: Scalars['Boolean'];
  maintenanceEndDateTime?: Maybe<Scalars['String']>;
  maintenanceStartDateTime?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of DeleteAllCartItems */
export type DeleteAllCartItemsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of DeleteAllCartItems */
export type DeleteAllCartItemsPayload = {
  __typename?: 'DeleteAllCartItemsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Errors encountered during execution of the mutation. */
  errors: Array<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated input type of DeleteCartItem */
export type DeleteCartItemInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of DeleteCartItem */
export type DeleteCartItemPayload = {
  __typename?: 'DeleteCartItemPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Errors encountered during execution of the mutation. */
  errors: Array<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated input type of DeleteGroupBuyItem */
export type DeleteGroupBuyItemInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  uuid: Scalars['String'];
};

/** Autogenerated return type of DeleteGroupBuyItem */
export type DeleteGroupBuyItemPayload = {
  __typename?: 'DeleteGroupBuyItemPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Errors encountered during execution of the mutation. */
  errors: Array<Scalars['String']>;
  groupBuyItem?: Maybe<GroupBuyItem>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated input type of DeleteGroupBuyRequest */
export type DeleteGroupBuyRequestInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  uuid: Scalars['String'];
};

/** Autogenerated return type of DeleteGroupBuyRequest */
export type DeleteGroupBuyRequestPayload = {
  __typename?: 'DeleteGroupBuyRequestPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Errors encountered during execution of the mutation. */
  errors: Array<Scalars['String']>;
  groupBuyItem?: Maybe<GroupBuyItem>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated input type of Delete */
export type DeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  uuid: Scalars['String'];
};

/** Autogenerated return type of Delete */
export type DeletePayload = {
  __typename?: 'DeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Errors encountered during execution of the mutation. */
  errors: Array<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Attributes for duplicating submissions for reorder */
export type DuplicateSubmissionsForReorderAttributes = {
  firstOptionId: Scalars['ID'];
  sizes: Array<SizeItemAttributes>;
};

/** Autogenerated input type of DuplicateSubmissionsForReorder */
export type DuplicateSubmissionsForReorderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  displayId: Scalars['String'];
  attributes: DuplicateSubmissionsForReorderAttributes;
};

/** Autogenerated return type of DuplicateSubmissionsForReorder */
export type DuplicateSubmissionsForReorderPayload = {
  __typename?: 'DuplicateSubmissionsForReorderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Errors encountered during execution of the mutation. */
  errors: Array<Scalars['String']>;
  submissions: Array<Submission>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Edit Pattern data */
export type EditPattern = {
  __typename?: 'EditPattern';
  displayName: Scalars['String'];
  id: Scalars['ID'];
  image: Scalars['String'];
  lead: Scalars['String'];
};

/** Edit pattern aggregation type */
export type EditPatternAggregation = {
  __typename?: 'EditPatternAggregation';
  count: Scalars['Int'];
  editPatternDisplayName: Scalars['String'];
  editPatternName: Scalars['String'];
};

/** Estimate Item data */
export type EstimateItem = {
  __typename?: 'EstimateItem';
  acceptMultipleDeliveries: Scalars['Boolean'];
  addonPriceTaxIncluded: Scalars['Int'];
  addonPrintableSkuId?: Maybe<Scalars['ID']>;
  addonProductUnitPriceTaxIncluded: Scalars['Int'];
  amount: Scalars['Int'];
  baseShipmentFee?: Maybe<Scalars['Int']>;
  baseShipmentFeeTaxIncluded?: Maybe<Scalars['Int']>;
  campaignPlateCharge?: Maybe<Scalars['Int']>;
  campaignUnitPrice?: Maybe<Scalars['Float']>;
  convenienceStoreShortestDeliveryDate: Scalars['String'];
  convenienceStoreShortestShippingDate: Scalars['String'];
  displayPlateCharge: Scalars['Int'];
  fastShippingFeeTaxIncluded: Scalars['Int'];
  fastShippingUnitFeeTaxIncluded: Scalars['Int'];
  firstSelectedOption?: Maybe<SkuSelectionOption>;
  id?: Maybe<Scalars['ID']>;
  maxDeliveryAddress: Scalars['Int'];
  minMultipleDeliveryQuantity: Scalars['Int'];
  options: Array<Option>;
  plateCharge: Scalars['Int'];
  plateChargeTaxIncluded: Scalars['Int'];
  price: Scalars['Int'];
  priceWithCharges: Scalars['Int'];
  priceWithChargesTaxIncluded: Scalars['Int'];
  printableSku: PrintableSku;
  printableSkuId: Scalars['ID'];
  printingPriceTaxIncluded: Scalars['Int'];
  productId: Scalars['ID'];
  productName: Scalars['String'];
  productPriceTaxIncluded: Scalars['Int'];
  productUnitPriceTaxIncluded: Scalars['Int'];
  quantity: Scalars['Int'];
  quantityUnit: Scalars['String'];
  secondSelectedOption?: Maybe<SkuSelectionOption>;
  selectedAddonFirstOptionId?: Maybe<Scalars['ID']>;
  selectedAddonProductId?: Maybe<Scalars['ID']>;
  selectedAddonProductName?: Maybe<Scalars['String']>;
  selectedAddonQuantityUnit?: Maybe<Scalars['String']>;
  selectedColorPattern: SkuColorPattern;
  selectedEditPattern: SkuEditPattern;
  selectedOptionIds: Array<Scalars['ID']>;
  shipmentFee: Scalars['Int'];
  shortestDeliveryDate: Scalars['String'];
  shortestShippingDate: Scalars['String'];
  sizeItems: Array<SizeItem>;
  tax: Scalars['Int'];
  trial: Scalars['Boolean'];
  unitPrice: Scalars['Float'];
  unitPriceTaxIncluded: Scalars['Int'];
  user?: Maybe<User>;
  wrappingSelectedOption?: Maybe<SkuSelectionOption>;
};

/** Return estimate items */
export type EstimateItems = {
  __typename?: 'EstimateItems';
  amount: Scalars['Int'];
  couponDiscount?: Maybe<CouponDiscount>;
  fastShippingFeeTaxIncluded: Scalars['Int'];
  items: Array<EstimateItem>;
  originalPriceWithChargesTaxIncluded: Scalars['Int'];
  originalPricesTaxIncluded: Scalars['Int'];
  paymentFee: Scalars['Int'];
  paymentFeeTaxIncluded: Scalars['Int'];
  totalRepeatDiscountTaxIncluded: Scalars['Int'];
  totalShipmentFeeTaxIncluded: Scalars['Int'];
};

/** Facet object for searching products by facet key - values */
export type FacetInput = {
  facetKey: Scalars['String'];
  facetValues: Array<Scalars['String']>;
};

/** Facet key data */
export type FacetKey = {
  __typename?: 'FacetKey';
  colorCode: Scalars['String'];
  displayName: Scalars['String'];
  facetValues: Array<FacetValue>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

/** Facet key aggregation type */
export type FacetKeyAggregation = {
  __typename?: 'FacetKeyAggregation';
  canonicalSetting: Scalars['String'];
  count?: Maybe<Scalars['Int']>;
  facetKeyDisplayName: Scalars['String'];
  facetKeyDisplayOrder: Scalars['Int'];
  facetKeyId: Scalars['ID'];
  facetKeyName: Scalars['String'];
  facetKeyNumberOfFacetValuesDisplayed: Scalars['Int'];
  facetType: Scalars['String'];
  facetValues: Array<FacetValueAggregation>;
};

/** Facet value data */
export type FacetValue = {
  __typename?: 'FacetValue';
  displayName: Scalars['String'];
  iconImage?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

/** Facet value aggregation type */
export type FacetValueAggregation = {
  __typename?: 'FacetValueAggregation';
  count: Scalars['Int'];
  facetValueDisplayName: Scalars['String'];
  facetValueDisplayOrder: Scalars['Int'];
  facetValueId: Scalars['ID'];
  facetValueName: Scalars['String'];
};

/** Fast Shiping Limit Type */
export type FastShippingLimit = {
  __typename?: 'FastShippingLimit';
  remainingQuantity: Scalars['Int'];
};

/** Group Buy Item data */
export type GroupBuyItem = {
  __typename?: 'GroupBuyItem';
  acceptingInput: Scalars['Boolean'];
  addedToCart: Scalars['Boolean'];
  amount: Scalars['Int'];
  comment?: Maybe<Scalars['String']>;
  expiredDate?: Maybe<Scalars['ISO8601DateTime']>;
  groupBuyRequests: Array<GroupBuyRequest>;
  isLock: Scalars['Boolean'];
  previewFiles: Array<Scalars['String']>;
  price: Scalars['Int'];
  priceWithChargesTaxIncluded: Scalars['Int'];
  printableSku: PrintableSku;
  quantity: Scalars['Int'];
  requesterName: Scalars['String'];
  sizeItems: Array<SizeItem>;
  thumbnailImages: Array<Scalars['String']>;
  unitPriceTaxIncluded: Scalars['Int'];
  uuid: Scalars['String'];
};

/** Attributes for updating group buy item */
export type GroupBuyItemAttributes = {
  printableSkuId: Scalars['ID'];
  requesterName: Scalars['String'];
  comment?: Maybe<Scalars['String']>;
  expiredDate?: Maybe<Scalars['ISO8601DateTime']>;
};

/** Attributes for updating group buy item */
export type GroupBuyItemUpdateAttributes = {
  printableSkuId: Scalars['ID'];
  requesterName?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  expiredDate?: Maybe<Scalars['ISO8601DateTime']>;
  submissions?: Maybe<Array<Scalars['ID']>>;
  acceptingInput?: Maybe<Scalars['Boolean']>;
};

/** Group Buy Request data */
export type GroupBuyRequest = {
  __typename?: 'GroupBuyRequest';
  comment: Scalars['String'];
  createdAt: Scalars['ISO8601DateTime'];
  groupBuyItem: GroupBuyItem;
  quantity: Scalars['Int'];
  sizeItems: Array<SizeItem>;
  username: Scalars['String'];
  uuid: Scalars['String'];
};

/** Attributes for updating group buy request */
export type GroupBuyRequestAttributes = {
  sizeItems: Array<SizeItemAttributes>;
  username: Scalars['String'];
  comment?: Maybe<Scalars['String']>;
};

/** Attributes for updating group buy request */
export type GroupBuyRequestUpdateAttributes = {
  sizeItems?: Maybe<Array<SizeItemAttributes>>;
  username?: Maybe<Scalars['String']>;
};


/** Industry data */
export type Industry = {
  __typename?: 'Industry';
  carouselImages: Array<CarouselImage>;
  categoriesByIndustry: Array<Category>;
  description: Scalars['String'];
  displayName: Scalars['String'];
  iconImage: Scalars['String'];
  id: Scalars['ID'];
  industryName: Scalars['String'];
  seasonalRecommendedProducts: SeasonalRecommendedProductsByIndustry;
  topPageBestSellingProducts: Array<ProductSearchDetail>;
  topPageImage: Scalars['String'];
};

/** Category list for industry page v2 */
export type IndustryCategoryList = {
  __typename?: 'IndustryCategoryList';
  accessoriesIcon: Scalars['String'];
  allParentCategories: Array<Category>;
  otherCategories: Array<Category>;
  topParentCategories: Array<Category>;
};

/** Library product list data */
export type LibraryProductList = {
  __typename?: 'LibraryProductList';
  category: Category;
  products: Array<Product>;
  totalItemsCount: Scalars['Int'];
};

/** Autogenerated input type of LockGroupBuyItem */
export type LockGroupBuyItemInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  uuid: Scalars['String'];
  acceptingInput: Scalars['Boolean'];
};

/** Autogenerated return type of LockGroupBuyItem */
export type LockGroupBuyItemPayload = {
  __typename?: 'LockGroupBuyItemPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Errors encountered during execution of the mutation. */
  errors: Array<Scalars['String']>;
  groupBuyItem?: Maybe<GroupBuyItem>;
  success?: Maybe<Scalars['Boolean']>;
};

export type MinMaxPrice = {
  __typename?: 'MinMaxPrice';
  maxPrice: Scalars['Int'];
  minPrice: Scalars['Int'];
};

/** Mutate data */
export type Mutation = {
  __typename?: 'Mutation';
  addBankAccountForRefunding?: Maybe<AddBankAccountPayload>;
  cancelOrder?: Maybe<CancelOrderPayload>;
  confirmOperatorModifiedSubmission?: Maybe<ConfirmOperatorModifiedSubmissionPayload>;
  confirmSubmission?: Maybe<ConfirmSubmissionPayload>;
  createCartItem?: Maybe<CreateCartItemPayload>;
  createCatalogRequest?: Maybe<CreateCatalogRequestPayload>;
  createContact?: Maybe<CreateContactPayload>;
  createEstimateItem?: Maybe<CreateEstimateItemPayload>;
  createFromGroupBuyItem?: Maybe<CreateFromGroupBuyItemPayload>;
  createFromUserDesign?: Maybe<CreateUserUploadImageFromUserDesignPayload>;
  createGroupBuyItem?: Maybe<CreateGroupBuyItemPayload>;
  createGroupBuyRequest?: Maybe<CreateGroupBuyRequestPayload>;
  createUserDesign?: Maybe<CreateUserDesignPayload>;
  createUserSizeRequest?: Maybe<CreateUserSizeRequestPayload>;
  deleteAllCartItems?: Maybe<DeleteAllCartItemsPayload>;
  deleteCartItem?: Maybe<DeleteCartItemPayload>;
  deleteGroupBuyItem?: Maybe<DeleteGroupBuyItemPayload>;
  deleteGroupBuyRequest?: Maybe<DeleteGroupBuyRequestPayload>;
  deleteUserDesign?: Maybe<DeletePayload>;
  duplicateSubmissionsForReorder?: Maybe<DuplicateSubmissionsForReorderPayload>;
  lockGroupBuyItem?: Maybe<LockGroupBuyItemPayload>;
  recartFromOrderItem?: Maybe<RecartFromOrderItemPayload>;
  reorder?: Maybe<ReorderPayload>;
  updateCartItem?: Maybe<UpdateCartItemPayload>;
  updateGroupBuyItem?: Maybe<UpdateGroupBuyItemPayload>;
  updateGroupBuyRequest?: Maybe<UpdateGroupBuyRequestPayload>;
  updateOrderItem?: Maybe<UpdateOrderItemPayload>;
  updateUserMarketingAttribute?: Maybe<UpdateUserMarketingAttributePayload>;
  uploadUserDesign?: Maybe<UploadUserDesignPayload>;
};


/** Mutate data */
export type MutationAddBankAccountForRefundingArgs = {
  input: AddBankAccountInput;
};


/** Mutate data */
export type MutationCancelOrderArgs = {
  input: CancelOrderInput;
};


/** Mutate data */
export type MutationConfirmOperatorModifiedSubmissionArgs = {
  input: ConfirmOperatorModifiedSubmissionInput;
};


/** Mutate data */
export type MutationConfirmSubmissionArgs = {
  input: ConfirmSubmissionInput;
};


/** Mutate data */
export type MutationCreateCartItemArgs = {
  input: CreateCartItemInput;
};


/** Mutate data */
export type MutationCreateCatalogRequestArgs = {
  input: CreateCatalogRequestInput;
};


/** Mutate data */
export type MutationCreateContactArgs = {
  input: CreateContactInput;
};


/** Mutate data */
export type MutationCreateEstimateItemArgs = {
  input: CreateEstimateItemInput;
};


/** Mutate data */
export type MutationCreateFromGroupBuyItemArgs = {
  input: CreateFromGroupBuyItemInput;
};


/** Mutate data */
export type MutationCreateFromUserDesignArgs = {
  input: CreateUserUploadImageFromUserDesignInput;
};


/** Mutate data */
export type MutationCreateGroupBuyItemArgs = {
  input: CreateGroupBuyItemInput;
};


/** Mutate data */
export type MutationCreateGroupBuyRequestArgs = {
  input: CreateGroupBuyRequestInput;
};


/** Mutate data */
export type MutationCreateUserDesignArgs = {
  input: CreateUserDesignInput;
};


/** Mutate data */
export type MutationCreateUserSizeRequestArgs = {
  input: CreateUserSizeRequestInput;
};


/** Mutate data */
export type MutationDeleteAllCartItemsArgs = {
  input: DeleteAllCartItemsInput;
};


/** Mutate data */
export type MutationDeleteCartItemArgs = {
  input: DeleteCartItemInput;
};


/** Mutate data */
export type MutationDeleteGroupBuyItemArgs = {
  input: DeleteGroupBuyItemInput;
};


/** Mutate data */
export type MutationDeleteGroupBuyRequestArgs = {
  input: DeleteGroupBuyRequestInput;
};


/** Mutate data */
export type MutationDeleteUserDesignArgs = {
  input: DeleteInput;
};


/** Mutate data */
export type MutationDuplicateSubmissionsForReorderArgs = {
  input: DuplicateSubmissionsForReorderInput;
};


/** Mutate data */
export type MutationLockGroupBuyItemArgs = {
  input: LockGroupBuyItemInput;
};


/** Mutate data */
export type MutationRecartFromOrderItemArgs = {
  input: RecartFromOrderItemInput;
};


/** Mutate data */
export type MutationReorderArgs = {
  input: ReorderInput;
};


/** Mutate data */
export type MutationUpdateCartItemArgs = {
  input: UpdateCartItemInput;
};


/** Mutate data */
export type MutationUpdateGroupBuyItemArgs = {
  input: UpdateGroupBuyItemInput;
};


/** Mutate data */
export type MutationUpdateGroupBuyRequestArgs = {
  input: UpdateGroupBuyRequestInput;
};


/** Mutate data */
export type MutationUpdateOrderItemArgs = {
  input: UpdateOrderItemInput;
};


/** Mutate data */
export type MutationUpdateUserMarketingAttributeArgs = {
  input: UpdateUserMarketingAttributeInput;
};


/** Mutate data */
export type MutationUploadUserDesignArgs = {
  input: UploadUserDesignInput;
};

/** Naming Editor data */
export type NamingEditor = {
  __typename?: 'NamingEditor';
  displayHeight: Scalars['Float'];
  displayName: Scalars['String'];
  displayOrder: Scalars['Int'];
  displayWidth: Scalars['Float'];
  editPatternIcon: Scalars['String'];
  height: Scalars['Float'];
  heightMm: Scalars['Float'];
  id: Scalars['ID'];
  left: Scalars['Float'];
  thumbnail: Scalars['String'];
  top: Scalars['Float'];
  width: Scalars['Float'];
  widthMm: Scalars['Float'];
};

/** Return information about np payment */
export type NpCredit = {
  __typename?: 'NpCredit';
  fee: Scalars['Int'];
  isMaintenanceScheduled: Scalars['Boolean'];
  isUnderMaintenance: Scalars['Boolean'];
  maintenanceEndDateTime?: Maybe<Scalars['String']>;
  maintenanceStartDateTime?: Maybe<Scalars['String']>;
};

/** Option data */
export type Option = {
  __typename?: 'Option';
  attribute1: Scalars['String'];
  attribute2?: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  id: Scalars['ID'];
  image: Scalars['String'];
  priceTaxIncluded: Scalars['Int'];
  totalPriceTaxIncluded: Scalars['Int'];
};

/** Order data */
export type Order = {
  __typename?: 'Order';
  allowCancel: Scalars['Boolean'];
  amount: Scalars['Int'];
  canCreateDeliveryNote: Scalars['Boolean'];
  canCreateInvoice: Scalars['Boolean'];
  canCreateReceipt: Scalars['Boolean'];
  contactToCancel: Scalars['Boolean'];
  createdAt: Scalars['String'];
  displayId: Scalars['String'];
  id: Scalars['ID'];
  orderItems: Array<OrderItem>;
  paymentMethod: Scalars['String'];
  refund: Scalars['Boolean'];
  status: OrderStatusEnum;
};

/** Order Item data */
export type OrderItem = {
  __typename?: 'OrderItem';
  aliasName: Scalars['String'];
  amountTaxIncluded: Scalars['Int'];
  amountWithCouponTaxIncluded: Scalars['Int'];
  availableSizes: Array<Size>;
  colorPatternName: Scalars['String'];
  displayId: Scalars['String'];
  displayPlateCharge: Scalars['Int'];
  displayPlateChargeTaxIncluded: Scalars['Int'];
  fastShippingFeeTaxIncluded: Scalars['Int'];
  firstSelectedOption?: Maybe<SkuSelectionOption>;
  freePlateChargeExpires?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isFastShipping: Scalars['Boolean'];
  isOrchidEmbroideryText: Scalars['Boolean'];
  namingEditors: Array<Scalars['String']>;
  options: Array<Option>;
  plainGood: Scalars['Boolean'];
  plateChargeTaxIncluded: Scalars['Int'];
  previewFiles?: Maybe<Array<Maybe<Scalars['String']>>>;
  previousStatus?: Maybe<Scalars['String']>;
  printableSkuId: Scalars['ID'];
  printingPriceTaxIncluded: Scalars['Int'];
  productId: Scalars['ID'];
  productName: Scalars['String'];
  productPriceTaxIncluded: Scalars['Int'];
  productUnitPriceTaxIncluded: Scalars['Int'];
  productUrl: Scalars['String'];
  quantity: Scalars['Int'];
  quantityUnit: Scalars['String'];
  recipientAddresses: Array<RecipientAddress>;
  reorder: Scalars['Boolean'];
  repeatDiscountTaxIncluded: Scalars['Int'];
  selectedColorPatternId: Scalars['ID'];
  selectedEditPatternId: Scalars['ID'];
  selectedPrintingColor?: Maybe<SkuPrintableSpecialColor>;
  senderAddress: SenderAddress;
  shipDate: Scalars['String'];
  shipmentFeeTaxIncluded: Scalars['Int'];
  sizeItems: Array<SizeItem>;
  status: OrderItemStatusEnum;
  submissionStatus: Scalars['String'];
  thumbnailImages?: Maybe<Array<Maybe<Scalars['String']>>>;
  totalCouponDiscountTaxIncluded: Scalars['Int'];
};

/** Order Item Revision data */
export type OrderItemRevision = {
  __typename?: 'OrderItemRevision';
  aliasName: Scalars['String'];
  amountTaxIncluded: Scalars['Int'];
  amountWithCouponTaxIncluded: Scalars['Int'];
  availableSizes: Array<Size>;
  colorPatternName: Scalars['String'];
  designChangesContent: Scalars['String'];
  designConfirmShippingDate: Scalars['String'];
  displayId: Scalars['String'];
  displayPlateCharge: Scalars['Int'];
  displayPlateChargeTaxIncluded: Scalars['Int'];
  fastShippingFeeTaxIncluded: Scalars['Int'];
  firstSelectedOption?: Maybe<SkuSelectionOption>;
  freePlateChargeExpires?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isFastShipping: Scalars['Boolean'];
  isOrchidEmbroideryText: Scalars['Boolean'];
  namingEditors: Array<Scalars['String']>;
  operatorModifications: Array<Submission>;
  options: Array<Option>;
  plainGood: Scalars['Boolean'];
  plateChargeTaxIncluded: Scalars['Int'];
  previewFiles?: Maybe<Array<Maybe<Scalars['String']>>>;
  previousStatus?: Maybe<Scalars['String']>;
  printableSkuId: Scalars['ID'];
  printingPriceTaxIncluded: Scalars['Int'];
  productId: Scalars['ID'];
  productName: Scalars['String'];
  productPriceTaxIncluded: Scalars['Int'];
  productUnitPriceTaxIncluded: Scalars['Int'];
  productUrl: Scalars['String'];
  quantity: Scalars['Int'];
  quantityUnit: Scalars['String'];
  recipientAddresses: Array<RecipientAddress>;
  reorder: Scalars['Boolean'];
  repeatDiscountTaxIncluded: Scalars['Int'];
  selectedColorPatternId: Scalars['ID'];
  selectedEditPatternId: Scalars['ID'];
  selectedPrintingColor?: Maybe<SkuPrintableSpecialColor>;
  senderAddress: SenderAddress;
  shipDate: Scalars['String'];
  shipmentFeeTaxIncluded: Scalars['Int'];
  shippingDate: Scalars['String'];
  sizeItems: Array<SizeItem>;
  status: OrderItemStatusEnum;
  submissionStatus: Scalars['String'];
  thumbnailImage?: Maybe<Scalars['String']>;
  thumbnailImages?: Maybe<Array<Maybe<Scalars['String']>>>;
  totalCouponDiscountTaxIncluded: Scalars['Int'];
};

export enum OrderItemStatusEnum {
  Ordered = 'ordered',
  MaterialOrdered = 'material_ordered',
  PrintingOrdered = 'printing_ordered',
  Shipped = 'shipped',
  Delivered = 'delivered',
  UserCanceled = 'user_canceled',
  MerchantCanceled = 'merchant_canceled',
  SupplierCanceled = 'supplier_canceled',
  PaidCanceled = 'paid_canceled'
}

export enum OrderStatusEnum {
  Ordered = 'ordered',
  OrderConfirmed = 'order_confirmed',
  UserCanceled = 'user_canceled',
  MerchantCanceled = 'merchant_canceled',
  SupplierCanceled = 'supplier_canceled',
  PaidCanceled = 'paid_canceled',
  Accounted = 'accounted'
}

/** Ordered product data */
export type OrderedProduct = {
  __typename?: 'OrderedProduct';
  brand: Scalars['String'];
  description: Scalars['String'];
  displayName?: Maybe<Scalars['String']>;
  gender: Scalars['String'];
  id: Scalars['ID'];
  minProductPrice: Scalars['Float'];
  orderDisplayId: Scalars['String'];
  productImage: Scalars['String'];
  quantityUnit: Scalars['String'];
  url: Scalars['String'];
};

/** Pagination for orders */
export type Orders = {
  __typename?: 'Orders';
  items: Array<Order>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  totalItemsCount: Scalars['Int'];
};

/** Return information about various payment options */
export type PaymentMethods = {
  __typename?: 'PaymentMethods';
  convenienceInfo: ConvenienceInfo;
  creditCard: CreditCard;
  npCredit: NpCredit;
};

/** Prefecture data */
export type Prefecture = {
  __typename?: 'Prefecture';
  id: Scalars['ID'];
  name: Scalars['String'];
};

/** Printable Sku data */
export type PrintableSku = {
  __typename?: 'PrintableSku';
  colorPattern: ColorPattern;
  id: Scalars['ID'];
  maxQuantity: Scalars['Int'];
  minQuantity: Scalars['Int'];
  sku: Sku;
  skuColorPattern: SkuColorPattern;
  skuEditPattern: SkuEditPattern;
  skuPrintableCmykColors: Array<SkuPrintableCmykColor>;
  skuPrintableSpecialColors: Array<SkuPrintableSpecialColor>;
  supplierId: Scalars['ID'];
  tutorialContent?: Maybe<Tutorial>;
};

/** Printing method aggregation type */
export type PrintingMethodAggregation = {
  __typename?: 'PrintingMethodAggregation';
  full?: Maybe<Scalars['Int']>;
  single: Scalars['Int'];
};

/** Product data */
export type Product = {
  __typename?: 'Product';
  brand: Scalars['String'];
  brandName: Scalars['String'];
  campaignLowestPrice?: Maybe<Scalars['Float']>;
  category: Category;
  categoryId: Scalars['ID'];
  content?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  detail?: Maybe<Scalars['String']>;
  disableFirstOptionWhenReorder: Scalars['Boolean'];
  disableSecondOptionWhenReorder: Scalars['Boolean'];
  displayName?: Maybe<Scalars['String']>;
  fastShippingMarkup?: Maybe<Scalars['Int']>;
  fastShippingProductId?: Maybe<Scalars['ID']>;
  gender: Scalars['String'];
  hasAddonProducts: Scalars['Boolean'];
  hasOptions: Scalars['Boolean'];
  id: Scalars['ID'];
  industry: Industry;
  isFastShipping: Scalars['Boolean'];
  isPlainGoodOnly: Scalars['Boolean'];
  lead: Scalars['String'];
  lowestPrice: Scalars['Float'];
  mainImageAlt?: Maybe<Scalars['String']>;
  minQuantity: Scalars['Int'];
  normalProductId?: Maybe<Scalars['ID']>;
  plainGoodFastShipping: Scalars['Boolean'];
  plainGoodFastShippingMarkup?: Maybe<Scalars['Int']>;
  precaution?: Maybe<Scalars['String']>;
  productCardItems: Array<ProductCardItem>;
  productImage: Scalars['String'];
  productType: Scalars['String'];
  publishStatus: Scalars['String'];
  quantityUnit: Scalars['String'];
  shortDisplayName: Scalars['String'];
  skus: Array<Sku>;
  url: Scalars['String'];
};

/** Return product's information filtered by options combined to a printable_sku */
export type ProductByPrintableSku = {
  __typename?: 'ProductByPrintableSku';
  addedToEstimate: Scalars['Boolean'];
  estimate: EstimateItem;
  plainGoodFastShippingDisabled: Scalars['Boolean'];
  printableSkuId: Scalars['ID'];
  product: Product;
  productCardItems: Array<ProductCardItem>;
  searchTags: Array<SearchTag>;
  sku: Sku;
  skuPrintableCmykColors: Array<SkuPrintableCmykColor>;
  skuPrintableSpecialColors: Array<SkuPrintableSpecialColor>;
};

/** Product card item data */
export type ProductCardItem = {
  __typename?: 'ProductCardItem';
  color: Scalars['String'];
  productCardDisplayName: Scalars['String'];
};

/** Product category data */
export type ProductCategory = {
  __typename?: 'ProductCategory';
  childCategories?: Maybe<Array<ProductCategory>>;
  displayName: Scalars['String'];
  iconImage?: Maybe<Scalars['String']>;
  iconImageAlt?: Maybe<Scalars['String']>;
  iconImageUrl: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  shortDisplayName: Scalars['String'];
  url: Scalars['String'];
};

export enum ProductDetailShippingEnum {
  SameDay = 'same_day'
}

/** Search product result with new unit */
export type ProductSearch = {
  __typename?: 'ProductSearch';
  categories: Array<CategorySearchResult>;
  designImage?: Maybe<Scalars['String']>;
  editPatterns: Array<EditPatternAggregation>;
  facets: Array<FacetKeyAggregation>;
  items: Array<ProductSearchDetail>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  printingMethod: PrintingMethodAggregation;
  totalItemsCount: Scalars['Int'];
};

/** Product search detail */
export type ProductSearchDetail = {
  __typename?: 'ProductSearchDetail';
  brand: Scalars['String'];
  categoryId: Scalars['ID'];
  description: Scalars['String'];
  displayName?: Maybe<Scalars['String']>;
  gender: Scalars['String'];
  hasFastShipping: Scalars['Boolean'];
  id: Scalars['ID'];
  industryName?: Maybe<Scalars['String']>;
  minProductPrice: Scalars['Float'];
  productCardItems: Array<ProductCardItem>;
  quantityUnit: Scalars['String'];
  score?: Maybe<Scalars['Float']>;
  sizeNames?: Maybe<Array<Scalars['String']>>;
  skuDetails: Array<SkuSearchDetail>;
  skuDetailsNonSearchPage: Array<SkuSearchDetail>;
  url: Scalars['String'];
};

/** Return products filter by tag */
export type ProductsGroupByTag = {
  __typename?: 'ProductsGroupByTag';
  /** id */
  id: Scalars['ID'];
  products?: Maybe<Array<Product>>;
  tagName?: Maybe<Scalars['String']>;
};


/** Return products filter by tag */
export type ProductsGroupByTagProductsArgs = {
  categoryId?: Maybe<Scalars['ID']>;
};

/** Get data */
export type Query = {
  __typename?: 'Query';
  /** Query all addon products for main product */
  addonProducts: Array<AddonProduct>;
  /** Query announcements by place */
  announcements: Array<Announcement>;
  /** Query application data */
  applicationData: ApplicationData;
  /** Query bank branches by keyword */
  bankBranchesByKeyword: Array<BankBranch>;
  /** Query banks by keyword */
  banksByKeyword: Array<Bank>;
  /** Query all brands */
  brands: Array<Brand>;
  /** Query all user cart items */
  cartItems: CartItems;
  /** Return categories */
  categories: Array<ProductCategory>;
  /** Return categories of products with same brand */
  categoriesByBrand: Array<Category>;
  /** Return categories of products with same industry */
  categoriesByIndustry: Array<Category>;
  /** Return categories of products with same industry for top page v2 */
  categoriesByIndustryV2: IndustryCategoryList;
  /** Query category by name */
  category?: Maybe<Category>;
  /** List Cms Categories */
  cmsCategories?: Maybe<CmsCategories>;
  /** Query a cms category information */
  cmsCategory?: Maybe<CmsCategory>;
  /** Query a cms magazine information based on path */
  cmsMagazine?: Maybe<CmsMagazine>;
  /** List CmsMagazines */
  cmsMagazines?: Maybe<CmsMagazines>;
  /** Query all cms links of a cms mapping */
  cmsMapping: CmsMapping;
  /** Query design for cross sell logo */
  crossSellLogoDesign?: Maybe<UserDesign>;
  /** Query naming editors for cross sell logo */
  crossSellLogoNamingEditors: Array<NamingEditor>;
  /** Query edit patterns by category */
  editPatterns: Array<EditPattern>;
  /** Query estimate by printable sku and parameters */
  estimate: EstimateItem;
  /** Query fast shipping limit */
  fastShippingLimit: FastShippingLimit;
  /** Return categories with full color products */
  fullColorCategories: Array<Category>;
  /** Return full color product list by category */
  fullColorProductsByCategory?: Maybe<LibraryProductList>;
  /** Query all function facet keys along with facet values */
  functionFacets: Array<FacetKey>;
  /** Query group buy item information */
  groupBuyItem?: Maybe<GroupBuyItem>;
  /** Query group buy items information */
  groupBuyItems: Array<GroupBuyItem>;
  /** Query all industries */
  industries: Array<Industry>;
  /** Query industry information */
  industry?: Maybe<Industry>;
  /** Query min max price for search page */
  minMaxPrice?: Maybe<MinMaxPrice>;
  /** Query order information */
  order?: Maybe<Order>;
  /** Query order item revision info */
  orderItemRevision?: Maybe<OrderItemRevision>;
  /** Query all user order item revisions */
  orderItemRevisions: Array<OrderItemRevision>;
  /** Query ordered products */
  orderedProducts: Array<OrderedProduct>;
  /** Query all user orders */
  orders?: Maybe<Orders>;
  paymentMethods: PaymentMethods;
  /** Query all prefectures */
  prefectures: Array<Prefecture>;
  /** Query printable sku by psi */
  printableSku: PrintableSku;
  /** Query product by id */
  productByPrintableSku: ProductByPrintableSku;
  /** Query product estimate items */
  productEstimateItems: EstimateItems;
  /** Query all options for product */
  productOptions: Array<Option>;
  /** Return product related categories */
  productRelatedCategories: Array<Category>;
  /** Search the product by conditions */
  productSearch: ProductSearch;
  /** Return recommended brands by industry for mobile */
  recommendedBrandsByIndustry: Array<Brand>;
  /** Return recommended categories by industry for mobile */
  recommendedCategoriesByIndustry: Array<Category>;
  /** Query seasonal recommended products by industry */
  seasonalRecommendedProductsByIndustry: SeasonalRecommendedProductsByIndustry;
  /** Query similar products with the product id and pagination params */
  similarProductsBy: SimilarProductBy;
  /** Return sku color patterns and edit patterns mapping */
  skuColorPatternEditPatternMapping?: Maybe<Array<SkuColorPatternEditPattern>>;
  /** Query submission information */
  submission?: Maybe<Submission>;
  /** Query submissions of a cart item */
  submissionsByCartItem: Array<Submission>;
  /** Query top page carousel images */
  topPageCarouselImages: Array<CarouselImage>;
  /** Query top page industries */
  topPageIndustries: Array<Industry>;
  /** Query top page recommended cagegories */
  topPageRecommendedCategories: Array<Category>;
  /** Query orders with unpaid convenience store payments */
  unpaidConvenienceStoreOrders: Array<Order>;
  /** Query current user information */
  user?: Maybe<User>;
  /** Query user design information */
  userDesign?: Maybe<UserDesign>;
  /** Query user design version information */
  userDesignVersion?: Maybe<UserDesignVersion>;
  /** Query all user designs */
  userDesigns: Array<UserDesign>;
  userMarketingAttribute?: Maybe<UserMarketingAttribute>;
  /** Query user notifications by place */
  userNotifications: Array<UserNotification>;
  /** Query viewed products */
  viewedProducts: Array<ViewedProduct>;
  /** Query zipcode by code */
  zipCode?: Maybe<ZipCode>;
};


/** Get data */
export type QueryAddonProductsArgs = {
  productId: Scalars['ID'];
};


/** Get data */
export type QueryAnnouncementsArgs = {
  place: AnnouncementPlaceEnum;
};


/** Get data */
export type QueryBankBranchesByKeywordArgs = {
  bankName: Scalars['String'];
  keyword?: Maybe<Scalars['String']>;
};


/** Get data */
export type QueryBanksByKeywordArgs = {
  keyword?: Maybe<Scalars['String']>;
};


/** Get data */
export type QueryCartItemsArgs = {
  isBuyLater?: Maybe<Scalars['Boolean']>;
};


/** Get data */
export type QueryCategoriesByBrandArgs = {
  brandId: Scalars['ID'];
};


/** Get data */
export type QueryCategoriesByIndustryArgs = {
  industryId: Scalars['ID'];
};


/** Get data */
export type QueryCategoriesByIndustryV2Args = {
  industryId: Scalars['ID'];
};


/** Get data */
export type QueryCategoryArgs = {
  name: Scalars['String'];
};


/** Get data */
export type QueryCmsCategoriesArgs = {
  offset: Scalars['Int'];
  limit: Scalars['Int'];
};


/** Get data */
export type QueryCmsCategoryArgs = {
  id?: Maybe<Scalars['ID']>;
  parentCategory?: Maybe<Scalars['String']>;
  childCategory?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  offset: Scalars['Int'];
  limit: Scalars['Int'];
};


/** Get data */
export type QueryCmsMagazineArgs = {
  path: Scalars['String'];
};


/** Get data */
export type QueryCmsMagazinesArgs = {
  magazineType: Scalars['String'];
  offset: Scalars['Int'];
  limit: Scalars['Int'];
  keywords?: Maybe<Array<Scalars['String']>>;
};


/** Get data */
export type QueryCmsMappingArgs = {
  mappableType: CmsMappingTypeEnum;
  mappableIds: Array<Scalars['ID']>;
};


/** Get data */
export type QueryEditPatternsArgs = {
  categoryId?: Maybe<Scalars['ID']>;
};


/** Get data */
export type QueryEstimateArgs = {
  printableSkuId: Scalars['ID'];
  sizes?: Maybe<Scalars['String']>;
  addonPrintableSkuId?: Maybe<Scalars['ID']>;
  originalOrderItemId?: Maybe<Scalars['ID']>;
};


/** Get data */
export type QueryFastShippingLimitArgs = {
  psi: Scalars['ID'];
};


/** Get data */
export type QueryFullColorProductsByCategoryArgs = {
  categoryId?: Maybe<Scalars['ID']>;
  offset: Scalars['Int'];
  limit: Scalars['Int'];
};


/** Get data */
export type QueryFunctionFacetsArgs = {
  industryId: Scalars['ID'];
};


/** Get data */
export type QueryGroupBuyItemArgs = {
  uuid: Scalars['String'];
};


/** Get data */
export type QueryIndustryArgs = {
  name: Scalars['String'];
};


/** Get data */
export type QueryOrderArgs = {
  displayId: Scalars['String'];
};


/** Get data */
export type QueryOrderItemRevisionArgs = {
  id?: Maybe<Scalars['ID']>;
  displayId?: Maybe<Scalars['String']>;
};


/** Get data */
export type QueryOrdersArgs = {
  offset: Scalars['Int'];
  limit: Scalars['Int'];
  status: SearchOrderStatusEnum;
};


/** Get data */
export type QueryPrintableSkuArgs = {
  psi: Scalars['ID'];
};


/** Get data */
export type QueryProductByPrintableSkuArgs = {
  id: Scalars['ID'];
  firstOptionId?: Maybe<Scalars['ID']>;
  skuEditPatternId?: Maybe<Scalars['ID']>;
  skuColorPatternId?: Maybe<Scalars['ID']>;
  sizes?: Maybe<Scalars['String']>;
  psi?: Maybe<Scalars['ID']>;
  addonProductId?: Maybe<Scalars['ID']>;
  addonFirstOptionId?: Maybe<Scalars['ID']>;
  addonPsi?: Maybe<Scalars['ID']>;
  resetInvalidSizeInput?: Maybe<Scalars['Boolean']>;
  prefectureId?: Maybe<Scalars['ID']>;
  optionIds?: Maybe<Array<Scalars['ID']>>;
  shipping?: Maybe<ProductDetailShippingEnum>;
};


/** Get data */
export type QueryProductEstimateItemsArgs = {
  psi: Scalars['ID'];
  sizes: Scalars['String'];
  paymentMethod?: Maybe<Scalars['String']>;
  addressesCount?: Maybe<Scalars['Int']>;
  addonPsi?: Maybe<Scalars['ID']>;
  addonAddressesCount?: Maybe<Scalars['Int']>;
  couponCode?: Maybe<Scalars['String']>;
  optionIds?: Maybe<Array<Scalars['ID']>>;
};


/** Get data */
export type QueryProductOptionsArgs = {
  productId: Scalars['ID'];
};


/** Get data */
export type QueryProductRelatedCategoriesArgs = {
  productId: Scalars['ID'];
};


/** Get data */
export type QueryProductSearchArgs = {
  categoryId?: Maybe<Scalars['ID']>;
  industryIds?: Maybe<Array<Scalars['ID']>>;
  minUnitPrice?: Maybe<Scalars['Int']>;
  maxUnitPrice?: Maybe<Scalars['Int']>;
  printingMethods?: Maybe<Array<Scalars['String']>>;
  editPatterns?: Maybe<Array<Scalars['String']>>;
  facets?: Maybe<Array<FacetInput>>;
  keyword?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<SearchSortEnum>;
  offset: Scalars['Int'];
  limit: Scalars['Int'];
  userDesignVersionUuid?: Maybe<Scalars['String']>;
};


/** Get data */
export type QueryRecommendedBrandsByIndustryArgs = {
  industryId: Scalars['ID'];
};


/** Get data */
export type QueryRecommendedCategoriesByIndustryArgs = {
  industryId: Scalars['ID'];
};


/** Get data */
export type QuerySeasonalRecommendedProductsByIndustryArgs = {
  industryId: Scalars['ID'];
};


/** Get data */
export type QuerySimilarProductsByArgs = {
  id: Scalars['ID'];
  offset: Scalars['Int'];
  limit: Scalars['Int'];
  type: Scalars['String'];
};


/** Get data */
export type QuerySkuColorPatternEditPatternMappingArgs = {
  skuId: Scalars['ID'];
};


/** Get data */
export type QuerySubmissionArgs = {
  uuid: Scalars['String'];
};


/** Get data */
export type QuerySubmissionsByCartItemArgs = {
  cartItemId: Scalars['ID'];
};


/** Get data */
export type QueryUserDesignArgs = {
  uuid: Scalars['String'];
};


/** Get data */
export type QueryUserDesignVersionArgs = {
  uuid?: Maybe<Scalars['String']>;
  userDesignUuid?: Maybe<Scalars['String']>;
  transparent?: Maybe<Scalars['Boolean']>;
};


/** Get data */
export type QueryUserNotificationsArgs = {
  place: UserNotificationPlaceEnum;
};


/** Get data */
export type QueryZipCodeArgs = {
  code: Scalars['String'];
};

/** Autogenerated input type of RecartFromOrderItem */
export type RecartFromOrderItemInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  displayId: Scalars['String'];
};

/** Autogenerated return type of RecartFromOrderItem */
export type RecartFromOrderItemPayload = {
  __typename?: 'RecartFromOrderItemPayload';
  cartItem?: Maybe<CartItem>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Errors encountered during execution of the mutation. */
  errors: Array<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Recipient Address data */
export type RecipientAddress = {
  __typename?: 'RecipientAddress';
  address1: Scalars['String'];
  address2: Scalars['String'];
  city: Scalars['String'];
  companyName?: Maybe<Scalars['String']>;
  deliveryStatusUrls: Array<Scalars['String']>;
  department?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  personalName: Scalars['String'];
  personalNameRuby: Scalars['String'];
  prefecture: Scalars['String'];
  promisedDeliveredDate: Scalars['String'];
  sizeItems: Array<SizeItem>;
  tel: Scalars['String'];
  zip: Scalars['String'];
};

/** RefundType data */
export type Refund = {
  __typename?: 'Refund';
  amount: Scalars['Int'];
  bankRefund?: Maybe<BankRefund>;
  fee: Scalars['Int'];
  handlingFee: Scalars['String'];
  id: Scalars['ID'];
  methodType: Scalars['String'];
  orderId: Scalars['ID'];
};

/** Attributes for reordering */
export type ReorderAttributes = {
  printableSkuId: Scalars['ID'];
  sizes: Array<SizeItemAttributes>;
  submissionUuids: Array<Scalars['String']>;
};

/** Autogenerated input type of Reorder */
export type ReorderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: ReorderAttributes;
};

/** Autogenerated return type of Reorder */
export type ReorderPayload = {
  __typename?: 'ReorderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Errors encountered during execution of the mutation. */
  errors: Array<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export enum SearchOrderStatusEnum {
  All = 'all',
  InProgress = 'in_progress',
  Completed = 'completed',
  Canceled = 'canceled'
}

export enum SearchSortEnum {
  SkuAsc = 'sku_asc',
  UnitPriceAsc = 'unit_price_asc',
  UnitPriceDesc = 'unit_price_desc',
  MinQuantityAsc = 'min_quantity_asc',
  DeliveryDateAsc = 'delivery_date_asc'
}

/** Search tag data */
export type SearchTag = {
  __typename?: 'SearchTag';
  categoryUrl: Scalars['String'];
  displayName: Scalars['String'];
  firstConditionValue: Scalars['String'];
  secondConditionType: Scalars['String'];
  secondConditionValue: Scalars['String'];
};

export type SeasonalRecommendedProductsByIndustry = {
  __typename?: 'SeasonalRecommendedProductsByIndustry';
  products: Array<ProductSearchDetail>;
  seasonName: Scalars['String'];
};

/** Sender Address data */
export type SenderAddress = {
  __typename?: 'SenderAddress';
  address1: Scalars['String'];
  address2: Scalars['String'];
  city: Scalars['String'];
  companyName?: Maybe<Scalars['String']>;
  department?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  personalName: Scalars['String'];
  personalNameRuby: Scalars['String'];
  prefecture: Scalars['String'];
  tel: Scalars['String'];
  zip: Scalars['String'];
};

/** Shortest Shipping Date Type */
export type ShortestShippingDate = {
  __typename?: 'ShortestShippingDate';
  fullColor?: Maybe<Scalars['String']>;
  singleColor?: Maybe<Scalars['String']>;
};

/** Pagination for similar products by series/industry and category */
export type SimilarProductBy = {
  __typename?: 'SimilarProductBy';
  items: Array<Product>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  totalItemsCount: Scalars['Int'];
};

/** Size data */
export type Size = {
  __typename?: 'Size';
  displayOrder: Scalars['Int'];
  hasStock: Scalars['Boolean'];
  id: Scalars['ID'];
  maxQuantity: Scalars['Int'];
  name: Scalars['String'];
  publishStatus: Scalars['String'];
  restockDate: Scalars['String'];
};

/** Size item data */
export type SizeItem = {
  __typename?: 'SizeItem';
  quantity: Scalars['Int'];
  sizeId: Scalars['ID'];
  sizeName: Scalars['String'];
};

/** Attributes for sizes input */
export type SizeItemAttributes = {
  id: Scalars['ID'];
  quantity: Scalars['Int'];
};

/** Size spec data */
export type SizeSpec = {
  __typename?: 'SizeSpec';
  from: Scalars['Float'];
  part: Scalars['String'];
  size: Scalars['String'];
  to: Scalars['Float'];
};

/** Sku data */
export type Sku = {
  __typename?: 'Sku';
  allSingleSkuEditPatterns: Array<SkuEditPattern>;
  allSkuEditPatterns: Array<SkuEditPattern>;
  availableSizes: Array<Size>;
  composition?: Maybe<Scalars['String']>;
  facetValues: Scalars['String'];
  firstOptions: Array<SkuSelectionOption>;
  firstSelectionOption?: Maybe<SkuSelectionOption>;
  id: Scalars['ID'];
  mappedSizeSpecs: Array<Array<SizeSpec>>;
  materialName?: Maybe<Scalars['String']>;
  product: Product;
  psi: Scalars['Int'];
  skuColorPattern: SkuColorPattern;
  skuColorPatterns: Array<SkuColorPattern>;
  skuEditPattern: SkuEditPattern;
  skuEditPatterns: Array<SkuEditPattern>;
  skuImage: SkuImage;
  skuImages: Array<SkuImage>;
};

/** Sku Color Pattern data */
export type SkuColorPattern = {
  __typename?: 'SkuColorPattern';
  colorPattern: ColorPattern;
  id: Scalars['ID'];
};

/** Sku color pattern and edit pattern mapping Type */
export type SkuColorPatternEditPattern = {
  __typename?: 'SkuColorPatternEditPattern';
  colorPattern: ColorPattern;
  id: Scalars['ID'];
  skuEditPatterns: Array<SkuEditPattern>;
};

/** Sku Edit Pattern data */
export type SkuEditPattern = {
  __typename?: 'SkuEditPattern';
  displayOrder: Scalars['Int'];
  editPattern: EditPattern;
  id: Scalars['ID'];
  image: Scalars['String'];
  namingEditors: Array<NamingEditor>;
};

/** Sku Image data */
export type SkuImage = {
  __typename?: 'SkuImage';
  caption: Scalars['String'];
  displayOrder: Scalars['Int'];
  id: Scalars['ID'];
  imageType: Scalars['String'];
  smallImage: Scalars['String'];
  thumbnail: Scalars['String'];
};

/** Sku Printable Cmyk Color data */
export type SkuPrintableCmykColor = {
  __typename?: 'SkuPrintableCmykColor';
  displayName: Scalars['String'];
  displayOrder: Scalars['Int'];
  id: Scalars['ID'];
  spotColor: SpotColor;
};

/** Sku Printable Special Color data */
export type SkuPrintableSpecialColor = {
  __typename?: 'SkuPrintableSpecialColor';
  displayName: Scalars['String'];
  displayOrder: Scalars['Int'];
  id: Scalars['ID'];
  spotColor: SpotColor;
};

/** Sku search detail */
export type SkuSearchDetail = {
  __typename?: 'SkuSearchDetail';
  firstSelectionOptionValue?: Maybe<Scalars['String']>;
  psi?: Maybe<Scalars['Int']>;
  skuImage?: Maybe<Scalars['String']>;
  smallSkuImage?: Maybe<Scalars['String']>;
};

/** Sku Selection data */
export type SkuSelection = {
  __typename?: 'SkuSelection';
  displayName: Scalars['String'];
};

/** Sku Selection Option data */
export type SkuSelectionOption = {
  __typename?: 'SkuSelectionOption';
  displayName: Scalars['String'];
  displayOrder: Scalars['Int'];
  hasStock: Scalars['Boolean'];
  id: Scalars['ID'];
  lead: Scalars['String'];
  selectable: Scalars['Boolean'];
  skuSelection: SkuSelection;
  skuSelectionId: Scalars['ID'];
  thumbnail: Scalars['String'];
};

/** Spot Color data */
export type SpotColor = {
  __typename?: 'SpotColor';
  blue?: Maybe<Scalars['Int']>;
  green?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  red?: Maybe<Scalars['Int']>;
  spotColorCode?: Maybe<Scalars['String']>;
  spotColorId: Scalars['String'];
  thumbnail: Scalars['String'];
};

/** Submission data */
export type Submission = {
  __typename?: 'Submission';
  exportedFile?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  namingEditor: NamingEditor;
  operatorModifiedExportedFile?: Maybe<Scalars['String']>;
  previewFile?: Maybe<Scalars['String']>;
  uuid: Scalars['String'];
};

/** Submission design info attributes */
export type SubmissionDesignInfoAttributes = {
  uuid: Scalars['String'];
  width: Scalars['Float'];
  height: Scalars['Float'];
  top: Scalars['Float'];
  left: Scalars['Float'];
};

/** Tutorial data */
export type Tutorial = {
  __typename?: 'Tutorial';
  content: Scalars['String'];
  imageUrl: Scalars['String'];
  title: Scalars['String'];
};

/** Attributes for updating cart item */
export type UpdateCartItemAttributes = {
  saveDesignToLibrary?: Maybe<Scalars['Boolean']>;
  designInfo?: Maybe<Array<SubmissionDesignInfoAttributes>>;
  sizes?: Maybe<Array<SizeItemAttributes>>;
  skuPrintableSpecialColorIds?: Maybe<Array<Scalars['ID']>>;
  skuPrintableCmykColorIds?: Maybe<Array<Scalars['ID']>>;
  isBuyLater?: Maybe<Scalars['Boolean']>;
  skuColorPatternId?: Maybe<Scalars['ID']>;
  skuEditPatternId?: Maybe<Scalars['ID']>;
  usePlainGood?: Maybe<Scalars['Boolean']>;
  submissionUuids?: Maybe<Array<Scalars['String']>>;
  optionIds?: Maybe<Array<Scalars['ID']>>;
};

/** Autogenerated input type of UpdateCartItem */
export type UpdateCartItemInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  attributes: UpdateCartItemAttributes;
};

/** Autogenerated return type of UpdateCartItem */
export type UpdateCartItemPayload = {
  __typename?: 'UpdateCartItemPayload';
  cartItem?: Maybe<CartItem>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Errors encountered during execution of the mutation. */
  errors: Array<Scalars['String']>;
  overLimitQuantityError?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated input type of UpdateGroupBuyItem */
export type UpdateGroupBuyItemInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  uuid: Scalars['String'];
  attributes: GroupBuyItemUpdateAttributes;
};

/** Autogenerated return type of UpdateGroupBuyItem */
export type UpdateGroupBuyItemPayload = {
  __typename?: 'UpdateGroupBuyItemPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Errors encountered during execution of the mutation. */
  errors: Array<Scalars['String']>;
  groupBuyItem?: Maybe<GroupBuyItem>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated input type of UpdateGroupBuyRequest */
export type UpdateGroupBuyRequestInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  uuid: Scalars['String'];
  attributes: GroupBuyRequestUpdateAttributes;
};

/** Autogenerated return type of UpdateGroupBuyRequest */
export type UpdateGroupBuyRequestPayload = {
  __typename?: 'UpdateGroupBuyRequestPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Errors encountered during execution of the mutation. */
  errors: Array<Scalars['String']>;
  groupBuyItem?: Maybe<GroupBuyItem>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated input type of UpdateOrderItem */
export type UpdateOrderItemInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  displayId: Scalars['String'];
  aliasName: Scalars['String'];
};

/** Autogenerated return type of UpdateOrderItem */
export type UpdateOrderItemPayload = {
  __typename?: 'UpdateOrderItemPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Errors encountered during execution of the mutation. */
  errors: Array<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Attributes for updating user marketing attribute */
export type UpdateUserMarketingAttribute = {
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  area?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  prefecture?: Maybe<Scalars['String']>;
  rejectedDirectMail?: Maybe<Scalars['Boolean']>;
  zipCode: Scalars['String'];
};

/** Autogenerated input type of UpdateUserMarketingAttribute */
export type UpdateUserMarketingAttributeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  attributes: UpdateUserMarketingAttribute;
};

/** Autogenerated return type of UpdateUserMarketingAttribute */
export type UpdateUserMarketingAttributePayload = {
  __typename?: 'UpdateUserMarketingAttributePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Errors encountered during execution of the mutation. */
  errors: Array<Scalars['String']>;
  marketingAttribute?: Maybe<UserMarketingAttribute>;
  success?: Maybe<Scalars['Boolean']>;
};


/** Autogenerated input type of UploadUserDesign */
export type UploadUserDesignInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  file: Scalars['UploadFile'];
};

/** Autogenerated return type of UploadUserDesign */
export type UploadUserDesignPayload = {
  __typename?: 'UploadUserDesignPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Errors encountered during execution of the mutation. */
  errors: Array<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
  userUploadImageUuids: Array<Scalars['String']>;
};

/** User data */
export type User = {
  __typename?: 'User';
  companyName?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  fullName: Scalars['String'];
  fullNameKana: Scalars['String'];
  id: Scalars['ID'];
  raksulUid: Scalars['String'];
  tel: Scalars['String'];
};

/** User design data */
export type UserDesign = {
  __typename?: 'UserDesign';
  fileExtension: Scalars['String'];
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  isDefault: Scalars['Boolean'];
  nonTransparentVersion?: Maybe<UserDesignVersion>;
  supportedTransparency: UserDesignSupportedTransparencyEnum;
  transparentVersion?: Maybe<UserDesignVersion>;
  uuid: Scalars['String'];
};

export enum UserDesignFileExtensionEnum {
  Png = 'png',
  Jpeg = 'jpeg',
  Pdf = 'pdf',
  Psd = 'psd',
  Jpg = 'jpg',
  Ai = 'ai'
}

export enum UserDesignSupportedTransparencyEnum {
  Both = 'both',
  Transparent = 'transparent',
  NonTransparent = 'non_transparent'
}

/** User design version data */
export type UserDesignVersion = {
  __typename?: 'UserDesignVersion';
  imageUrl?: Maybe<Scalars['String']>;
  userDesign: UserDesign;
  uuid: Scalars['String'];
};

/** User Marketing Attribute data */
export type UserMarketingAttribute = {
  __typename?: 'UserMarketingAttribute';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  area?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  prefecture?: Maybe<Scalars['String']>;
  rejectedDirectMail?: Maybe<Scalars['Boolean']>;
  zipCode?: Maybe<Scalars['String']>;
};

/** UserNotification data */
export type UserNotification = {
  __typename?: 'UserNotification';
  content: Scalars['String'];
  displayMethod: Scalars['String'];
  id: Scalars['ID'];
  style: Scalars['String'];
  url?: Maybe<Scalars['String']>;
};

export enum UserNotificationPlaceEnum {
  Cart = 'cart',
  Category = 'category',
  Industry = 'industry',
  OrderHistory = 'order_history',
  Product = 'product',
  Top = 'top'
}

/** Viewed product data */
export type ViewedProduct = {
  __typename?: 'ViewedProduct';
  brand: Scalars['String'];
  description: Scalars['String'];
  displayName?: Maybe<Scalars['String']>;
  gender: Scalars['String'];
  id: Scalars['ID'];
  minProductPrice: Scalars['Float'];
  productImage: Scalars['String'];
  quantityUnit: Scalars['String'];
  url: Scalars['String'];
};

/** Zip code data */
export type ZipCode = {
  __typename?: 'ZipCode';
  address: Scalars['String'];
  city: Scalars['String'];
  prefecture: Scalars['String'];
  town: Scalars['String'];
  zip: Scalars['String'];
  zipCode: Scalars['String'];
};
